import { defineMessages } from 'react-intl';

export default defineMessages({
  imageSizeLimit: {
    id: 'app.components.ImageUpload.imageSizeLimit',
    defaultMessage: '(size limit 5MB)',
  },
});
